module.exports = __webpack_public_path__ + "static/img/1.621f8348.jpg";